import React, { useEffect, useState } from "react";
import Card from "../../components/Card/Card";
import { toast } from "react-toastify";
import http from "../../http-common";
import { Button, DataTable, Loading } from "carbon-components-react";
import { TableContainer } from "carbon-components-react";
import { TableToolbar } from "carbon-components-react";
import { Table } from "carbon-components-react";
import { TableHead } from "carbon-components-react";
import { TableRow } from "carbon-components-react";
import { TableBody } from "carbon-components-react";
import { TableCell } from "carbon-components-react";
import { TableHeader } from "carbon-components-react";

const tableHeaders = [
  {
    header: "Nome",
    key: "firstName",
  },
  {
    header: "Apelido",
    key: "lastName",
  },
  {
    header: "Telefone",
    key: "phoneNumber",
  },
  {
    header: "Desempate",
    key: "tiebreaker",
  },
  {
    header: "Planos de Negócio Atribuídos",
    key: "totalAssignedBusinessPlans",
  },
  {
    header: "Avaliados",
    key: "totalEvaluated",
  },
  {
    header: "Por Avaliar",
    key: "totalRemaining",
  },
];

const BusinessPlanJuryPanelPage = () => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [juryAssigned, setJuryAssigned] = useState(false);
  const [tiebrackerJuryAssigned, setTiebrackerJuryAssigned] = useState(false);

  const countEvaluations = async () => {
    try {
      const response = await http.get("/business-plan/count-evaluations");
      setJuryAssigned(response.data > 0 ? true : false);
    } catch (error) {
      toast.error("Erro ao carregar dados estatísticos");
    }
  };

  const getStats = async () => {
    try {
      const response = await http.get("/business-plan/jury-panel-stats");
      setStats(response.data);
    } catch (error) {
      toast.error("Erro ao carregar dados estatísticos");
    }
  };

  const assignBusinessPlansToJury = async () => {
    try {
      setLoading(true);
      const response = await http.put("/business-plan/assign-jury");
      toast.success("Atribuição de Planos de Negócio executada com sucesso");
      setJuryAssigned(true);
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
    setLoading(false);
  };

  const assignBusinessPlansToTiebreakerJury = async () => {
    try {
      setLoading(true);
      const response = await http.put("/business-plan/assign-tiebreaker-jury");
      toast.success("Atribuição de Planos de Negócio executada com sucesso");
      setTiebrackerJuryAssigned(true);
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    countEvaluations();
    getStats();
  }, [juryAssigned, tiebrackerJuryAssigned]);

  return (
    <Card title="Painel de júri - Planos de Negócio">
      <Loading
        active={loading}
        description="Active loading indicator"
        withOverlay={true}
      />
      {!juryAssigned && (
        <Button className="mb-2" onClick={assignBusinessPlansToJury}>
          Atribuir Planos de Negócio aos membros do júri
        </Button>
      )}
      {/* {juryAssigned && !tiebrackerJuryAssigned && (
        <Button className="mb-2" onClick={assignBusinessPlansToTiebreakerJury}>
          Atribuir júri de desempate
        </Button>
      )} */}
      <DataTable rows={stats} headers={tableHeaders} isSortable useZebraStyles>
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>{cell.value}</TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
    </Card>
  );
};

export default BusinessPlanJuryPanelPage;
